import React, { useMemo, useState } from 'react';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';

export function AmountCaptureList({ label, placeholder, entries, onAdd, onRemove }) {
  const [draftValue, setDraftValue] = useState('');

  const total = useMemo(
    () => entries.reduce((acc, amount) => acc + amount, 0),
    [entries],
  );

  const handleAdd = () => {
    const numericValue = Number(draftValue);
    if (Number.isFinite(numericValue) && numericValue > 0) {
      onAdd(numericValue);
      setDraftValue('');
    }
  };

  return (
    <Stack spacing={2}>
      <Stack spacing={1}>
        <Typography variant="subtitle1" fontWeight={600}>
          {label}
        </Typography>
        <Stack direction="row" spacing={1}>
          <TextField
            fullWidth
            size="small"
            type="number"
            placeholder={placeholder}
            value={draftValue}
            onChange={(event) => setDraftValue(event.target.value)}
            inputProps={{ min: 0 }}
          />
          <Button variant="contained" onClick={handleAdd}>
            Add
          </Button>
        </Stack>
      </Stack>

      <Stack spacing={1}>
        <Typography variant="body2" color="text.secondary">
          Total: {total.toLocaleString('en-US')} ₫
        </Typography>
        <Stack spacing={1}>
          {entries.length === 0 && (
            <Typography variant="body2" color="text.secondary">
              No transactions captured yet.
            </Typography>
          )}

          {entries.map((value, index) => (
            <Paper
              key={`${value}-${index}`}
              variant="outlined"
              sx={{ p: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
            >
              <Chip label={`Entry ${index + 1}`} size="small" />
              <Typography fontWeight={600}>{value.toLocaleString('en-US')} ₫</Typography>
              <IconButton onClick={() => onRemove(index)} color="error" size="small">
                <DeleteOutlineRoundedIcon fontSize="small" />
              </IconButton>
            </Paper>
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
}


